import { AtsGtmEvent, AtsGtmEventLabelDefault, PushAnalyticsEventsService } from '@alliance/ats/analytics/utils'
import { NgZoneHelperService } from '@alliance/shared/utils'
import { Directive, ElementRef, Input } from '@angular/core'
import { RxState } from '@rx-angular/state'
import { fromEvent } from 'rxjs'

@Directive({
  selector: '[atsAnalyticsPushEventOnClick]'
})
export class PushEventOnClickDirective<Label extends AtsGtmEventLabelDefault> extends RxState<object> {
  @Input() public event: AtsGtmEvent<Label> | null = null

  public constructor(private elementRef: ElementRef<HTMLElement>, private pushAnalyticsEventsService: PushAnalyticsEventsService, private ngZoneHelperService: NgZoneHelperService) {
    super()

    this.hold(fromEvent(this.elementRef.nativeElement, 'click').pipe(this.ngZoneHelperService.outsideNgZone()), () => {
      if (this.event) {
        const { event, labelParam } = this.event
        this.pushAnalyticsEventsService.pushEvent({ event, labelParam })
      }
    })
  }
}
